<template>
  <el-date-picker
    class="date-picker-start-end"
    v-bind="$attrs"
    v-on="mergedListeners"
    v-model="internalRange"
    type="daterange"
    start-placeholder="Start date"
    end-placeholder="End date"
    range-separator="To"
  />
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "DatePickerStartEnd",
  props: {
    startDate: {
      type: [String, Date, Number],
      default: null,
    },
    endDate: {
      type: [String, Date, Number],
      default: null,
    },
    outputType: {
      type: String,
      default: "timestamp", // 'timestamp' or 'utc'
      validator: (v) => ["timestamp", "utc"].includes(v),
    },
  },
  computed: {
    internalRange: {
      get() {
        return this.startDate && this.endDate
          ? [this.startDate, this.endDate]
          : [];
      },
      set(val) {
        let start = val ? val[0] : null;
        let end = val ? val[1] : null;
        if (this.outputType === "timestamp") {
          start = start ? dayjs(start).valueOf() : null;
          end = end ? dayjs(end).endOf("day").valueOf() : null;
        } else if (this.outputType === "utc") {
          start = start
            ? dayjs(start).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            : null;
          end = end
            ? dayjs(end).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            : null;
        }
        this.$emit("update:startDate", start);
        this.$emit("update:endDate", end);
        this.$emit("change", [start, end]);
        this.$emit("input", [start, end]);
      },
    },
    mergedListeners() {
      return {
        ...this.$listeners,
        input: (val) => {
          this.internalRange = val;
        },
      };
    },
  },
};
</script>
<style lang="scss">
.date-picker-start-end {
  .el-range-separator {
    width: 80px;
  }
}
</style>
